export const config = {
    HOME_PAGE_KEY: 'homePage',
    LOGIN_USER: {
        USER_ID: '',
        USER_NUM: '',
        VCC_ID: '',
        VCC_CODE: '',
    },
    // 用户默认
    DEFAULT_AVATAR: require("@/assets/images/default_avatar.png"),
    DEFAULT_LOGO: require("@/assets/images/default_logo.png"),

    // 接口相关
    TOKEN_KEY: 'ekt_access_token',
    TIME_OUT: 10 * 1000,

    MSG_WS: 'wss://message-service-test.icsoc.net',
    // 消息通知配置
    APP_NOTIFY: {
        autoCloseInterval: 5,
        isAutoClose: true,
        isEnableNotice: true, // 是否开启消息通知
        noticeType: "system", // system-应用内；browser-浏览器级别
        systemNoticePosition: "bottom-right" // 应用内提醒位置
    },

    // 导航栏公告走马灯切换尺寸
    MINI_SCREEN: 1635,
    // 内容最新宽度
    MIN_WIDTH: 1200,

    // 置顶公告刷新时间
    NOTICE_REFRESH_TIME: 1000 * 60 * 10,

    // postMessage的type码
    POST_MSG_TYPE: {
        CLOSE_TAB: '1',
        CLOSE_DIALOG: '1_1',
        MAKE_CALL: '2',
        MAKE_RTC_CALL: '2_1',
        OPEN_RTC_PANEL: '2_2',
        SEAT_MONITOR_OPERATE: '2_6', // 监控->通话监控->坐席监控 操作：监听/强拆/强插
        SEND_MSG: '3',
        OPEN_MODAL: '3_1',
        ADD_TAB: '4',
        VIEW_IMG: '4_1',
        SHINE_ICON: '500',
        NOTICE: '501',
        TRC_WEB_CHANGE_SIZE: 'rtc_web_size',
        NEW_CALL_POP_SCREEN: 'new_call_pop_screen' // 新电话座席工作台弹屏
    },

    // 各模块的域名
    URL: {},

    // 是否开启新版crm
    isEnableCrm: false,
    CRM_HOST: '',
    // 电话弹屏
    USER_OUT_CALL_POPUP: 1,
    TAB_NAME_CONFIG: null,
    POP_ADDRESS: null,

    // 存储key
    REDIRECT_URL: 'redirect-url'
}
// 企点电话条是否展开
export const QIDIAN_EXPAND = 'qidian_expand'

// 今日通话客户信息
export const TODAY_CALL_CUSTOMERS = 'today_call_customers'

export default config



// WEBPACK FOOTER //
// ./src/constant/index.js